export function BrandBadge({ size = 48, className = "" }) {
  return (
    <div
      className={`flex shrink-0 items-center justify-center rounded-lg bg-navy ${className}`}
      style={{ width: size, height: size }}
      data-testid="brand-badge"
    >
      <svg width={size * 0.6} height={size * 0.6} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3 8L9 30L15 12L21 30L27 8" stroke="#3B82F6" strokeWidth="4.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M27 8L33 30" stroke="#10B981" strokeWidth="4.5" strokeLinecap="round" strokeLinejoin="round" />
        <circle cx="33" cy="4.5" r="3" fill="#10B981" />
      </svg>
    </div>
  );
}
